var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"mb-0"},[_c('v-col',[_c('h1',[_vm._v("Задания пациента")])]),_c('v-col',{staticClass:"position-relative",attrs:{"align":"right"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.openTaskTemplates}},[_vm._v("Карты наблюдений")])],1)],1),_c('patient-header'),_c('tasks-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }